import { render, staticRenderFns } from "./TelegramBot.vue?vue&type=template&id=67fdfed1&"
import script from "./TelegramBot.vue?vue&type=script&lang=js&"
export * from "./TelegramBot.vue?vue&type=script&lang=js&"
import style0 from "./TelegramBot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports